// NOTIFICATION LIST
export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
export const NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_LIST_FAIL = "NOTIFICATION_LIST_FAIL";
export const NOTIFICATION_LIST_RESET = "NOTIFICATION_LIST_RESET";
export const NOTIFICATION_LIST_COLUMN = "NOTIFICATION_LIST_COLUMN";

// NOTIFICATION HEADER LIST
export const NOTIFICATION_HEADER_LIST = "NOTIFICATION_HEADER_LIST";
export const NOTIFICATION_HEADER_LIST_SUCCESS = "NOTIFICATION_HEADER_LIST_SUCCESS";
export const NOTIFICATION_HEADER_LIST_FAIL = "NOTIFICATION_HEADER_LIST_FAIL";
export const NOTIFICATION_HEADER_LIST_RESET = "NOTIFICATION_HEADER_LIST_RESET";
export const NOTIFICATION_HEADER_LIST_COLUMN = "NOTIFICATION_HEADER_LIST_COLUMN";

// NOTIFICATION DETAIL
export const NOTIFICATION_DETAIL = "NOTIFICATION_DETAIL";
export const NOTIFICATION_DETAIL_SUCCESS = "NOTIFICATION_DETAIL_SUCCESS";
export const NOTIFICATION_DETAIL_FAIL = "NOTIFICATION_DETAIL_FAIL";
export const NOTIFICATION_DETAIL_RESET = "NOTIFICATION_DETAIL_RESET";